<template>
    <div class="edit_wrap">
        <div class="pl10 pr10 mt20">
            <div class="pl10 mt20 mb20" v-if="infoData.schedule">
                <el-row>
                    <el-col :span="2">
                        <div class="grid-content">审核进展：</div>
                    </el-col>
                    <el-col :span="22"><div class="grid-content"><span class="main_word">{{ infoData.schedule.time*1000 | time }}&nbsp;&nbsp;{{ infoData.schedule.desc}}</span></div></el-col>
                </el-row>
                <el-row>
                    <el-col :span="22" :offset="2"><div class="grid-content" v-if="infoData.schedule.content">
                        ({{infoData.schedule.content}})</div></el-col>
                </el-row>
            </div>
            <p class="ml20">新增品牌基本信息</p>
            <div class="mt20 ml20">
                <el-form label-width="180px" class="demo-ruleForm">
                    <!-- 基础信息 -->
                    <el-form-item label="新增品牌申请编号：">
                        {{ infoData.brandAgreementCode }}
                    </el-form-item>
                    <el-form-item label="关联供应商合同编号：">
                        {{ infoData.contractCode }}
                    </el-form-item>
                    <el-form-item label="供应商编号：">
                        {{ infoData.supplierCode }}
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        {{ infoData.supplierName }}
                    </el-form-item>
                    <el-form-item label="合作方式：">
                        {{ infoData.cooperationTypeDesc }}
                    </el-form-item>
                    <el-form-item label="结算主体：">
                        <span v-if="infoData.settlementBodyId==1">北京果敢时代科技有限公司</span>
                        <span v-if="infoData.settlementBodyId==2">MAMA HONG KONG</span>
                        <span v-if="infoData.settlementBodyId==3">天津果敢时代国际贸易有限公司</span>
                        <span v-if="infoData.settlementBodyId==4">正合奇胜（天津）企业咨询管理有限公司</span>
                        <span v-if="infoData.settlementBodyId==5">老师线下打款</span>
                    </el-form-item>
                    <el-form-item label="合同有效期：">
                        {{ infoData.startTime | time }}至{{ infoData.endTime | time }}
                    </el-form-item>
                </el-form>
            </div>
            <p class="ml20">品牌品类信息</p>
            <div class="mt20 mb20 clearfix">
                <el-table :data="infoData.brandApplies" border style="width: 100%">
                    <el-table-column label="序号" width="74" align="center">
                        <template scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="品牌中文名称" min-width="80" align="center">
                        <template scope="scope">
                            <a :href="'#/common_detail?brandApplyId=' + scope.row.brandApplyId" target="_blank"><el-button type="text" size="small">{{ scope.row.brandName }}</el-button></a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="brandEnname" label="品牌英文名称" min-width="80" align="center"></el-table-column>
                    <el-table-column label="合作品类" min-width="120" align="center">
                        <template scope="scope">
                            <div class="bor_style" v-for="val in scope.row.categories">
                                {{ val.category.grandName }}-{{val.category.parentName}}-{{val.category.childrenName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template scope="scope">
                            <a target="_blank" :href="'index2#/common_detail'+'?brandApplyId=' + scope.row.brandApplyId + '&brandAgreementId='+ id">
                                <el-button type="text" size="small">查看</el-button>
                            </a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="mb20" align="center">
                <el-button type="primary" @click="reback()">返回</el-button>
            </div>
            <!--预览图片弹框-->
            <el-dialog :visible.sync="dialogVisible" size="small">
                <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>

        </div>
    </div>

</template>

<script type="text/javascript">
    export default {
        data () {
            return {
                dialogVisible: false,   // 预览弹框状态
                dialogImageUrl: '',     // 预览弹框url
                showReason:false,       // 驳回原因 是否展示状态
                // 驳回原因 内容
                scheduleObj:{
                    schedule:"1",
                    content:"2"
                },
                id: 0,
                infoData: {
                    // 品牌列表
                    brandApplies: []
                },
            }
        },
        methods: {
            fetch () {
                var _this = this;
                $.get({
                    url: "/suppliers/agreementApply/brandAgreementApply/find",
                    data: {
                        id: _this.id
                    },
                    success: function (result) {
                        if (!result.code && result.data) {
                            console.log(result.data)
                            _this.infoData = result.data;
                        }
                    }
                })
            },
            handleDelete (index, data) {
                data.splice(index,1)
            },
            // 返回
            reback(){
                window.close();
            }

        },

        mounted () {
            var id = this.$route.query.id;
            this.id = id;
            this.$nextTick(function () {
                this.fetch();
            })
        }
    }
</script>

<style type="text/css" lang="less" scoped>
    .edit_wrap {
        width: 1050px;
        margin: 50px auto;
        border: 1px solid #eee;
    }
    .link_a {
        border-bottom: 1px solid red;
    }
    .bor_style:not(:last-child) {
        margin-left: -18px;
        margin-right: -18px;
        border-bottom: 1px solid #eadadd;
    }
</style>


// WEBPACK FOOTER //
// skan_category_brand.vue?49ba46f8